module.exports = __webpack_public_path__ + "prod/1.42.2/img/pre_high_img1.70e86f3f.png";